import React from "react"
import style from "./productCard.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import ThreeDotDropdown from "../../Dropdown/ThreeDotsDropDown/DropDown";
import {Link} from "react-router-dom";

const ProductCard = (props) => {
    const arrayOne = [{
        name: "ویرایش نام کالا", onclick: () => {
            props.modalsHandler("editName", props.data._id, props.data.channel._id || props.data.channel, props.parentId)
        }, modalOpen: () => {
            doNothing()
        }
    }]
    const doNothing = () => {
    }

    return (
        <div className={style.container}>
            <div className={style.wrapper}>
                <div className={style.col1}>
                    <div className={style.firstGroup}>

                        <label className={style.label}>
                            :گروه
                        </label>
                        <p>{props.data.productGroup}</p>
                    </div>
                    <div className={style.firstGroup}>

                        <label className={style.label}>
                            :فروشنده
                        </label>
                        <p>{props.data.channel.name}</p>
                    </div>
                </div>
                <div className={style.col2}>
                    <div className={style.secondGroup}>
                        <label className={style.label}>
                            :تعداد تنوع
                        </label>
                        <p>{toPersianNumber(props.data.countOfVariant)}</p>
                    </div>
                    <div className={style.secondGroup}>
                        <label className={style.brandLabel}>
                            :برند
                        </label>
                        {/* {console.log("555",props.data)} */}
                        <p>{typeof props.data.brand !== "undefined" ? props.data.brand : "نامشخص"}</p>
                    </div>
                </div>

                <div className={style.col3}>
                    <div className={style.thirdGroup}>
                        <a href={"https://www.digikala.com/product/dkp-" + props.data.DKP} target="_blank">
                            <p>{toPersianNumber(props.data.newName)}</p></a>
                    </div>
                    <div className={style.thirdGroup}>

                        <label className={style.label}>
                            :کد کالا
                        </label>
                        <p>{"DKP - " + toPersianNumber(props.data.DKP)}</p>
                    </div>
                </div>
                <div className={style.col4}>
                    <Link style={{textDecoration: "none"}}
                          to={{pathname: `https://www.digikala.com/product/dkp-${props.data.DKP}`}} target="_blank">
                        <img src={props.data.imageSrc}/>
                    </Link>
                </div>
                <div className={style.col5}>
                    <div className={style.threeDotWrapper}>
                        <ThreeDotDropdown items={arrayOne}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProductCard;

